import React, { useEffect, useState } from "react"
import data from "../../data/content.json"
import { Row, Col, Image } from "react-bootstrap"
import { connect } from "react-redux"
import "../../style/Common/common.css"
import "./Partners.css"
/* import { getData } from "../../utils/page" */

import goldMicrosoft from "../../images/partners/goldMicrosoftPartner.svg"
import google from "../../images/partners/googleCloud.svg"
import huawei from "../../images/partners/Huawei.svg"
import ingram from "../../images/partners/ingramMicro.svg"
import lenovo from "../../images/partners/lenovo.svg"
import licenciasOnline from "../../images/partners/licenciasOnline.svg"
import progress from "../../images/partners/progress.svg"
import redHat from "../../images/partners/redHatPartnerConnect.svg"
import fortinet from "../../images/partners/fortinet.svg"
import elastic from "../../images/partners/elastic.svg"
let Partners = props => {
  const [showLogo, setShowLogo] = useState("hidden")
  const [hiddenLogo, setHiddenLogo] = useState("")
  const [change, setChange] = useState(3)
  let back = "max-width: 768px"

  useEffect(() => {
    back = window.matchMedia("(max-width: 991px)")
    back.addListener(handleLogo)
    handleLogo()
  })

  const handleLogo = () => {
    if (back.matches) {
      setShowLogo("")
      setHiddenLogo("hidden")
      setChange(4)
    } else {
      setShowLogo("hidden")
      setHiddenLogo("")
      setChange(3)
    }
  }

  return (
    <>
      <Row className={` ${props.classAnimationPartners}  imageSpacingPartner `}>
        <h1>{data.Home[props.app.lang].sectionPartner.title}</h1>
      </Row>
      <Row
        className={`justify-content-center  ${props.classAnimationPartners} fix-row `}
      >
        <Col
          xs={6}
          sm={6}
          md={6}
          lg={2}
          xl={2}
          className="align-self-center align-items-center"
        >
          {/* CAROUSEL ONE - ROW 1*/}
          <div id="position" className="align-self-center">
            <img alt="gold Microsoft Partner" src={goldMicrosoft} />
          </div>
        </Col>
        <Col
          xs={6}
          sm={6}
          md={6}
          lg={2}
          xl={2}
          className="align-self-center align-items-center"
        >
          {/* CAROUSEL TWO - ROW 1 */}
          <div id="position" className="align-self-center">
            <img alt="goole Clound" src={google} />
          </div>
        </Col>
        <Col
          xs={6}
          sm={6}
          md={6}
          lg={2}
          xl={2}
          className="align-self-center align-items-center"
        >
          {/* CAROUSEL THREE - ROW 1 */}
          <div id="position" className="align-self-center">
            <img alt="huawei" src={huawei} />
          </div>
        </Col>
        <Col
          xs={6}
          sm={6}
          md={6}
          lg={2}
          xl={2}
          className="align-self-center align-items-center"
        >
          {/* CAROUSEL THREE - ROW 1 */}
          <div id="position">
            <img alt="progress" src={progress} />
          </div>
        </Col>
        <Col
          xs={6}
          sm={6}
          md={6}
          lg={2}
          xl={2}
          className={` align-self-center align-items-center  ${hiddenLogo}`}
        >
          {/* CAROUSEL THREE - ROW 1 */}
          <div id="position">
            <img alt="redHat Partner Connect" src={redHat} />
          </div>
        </Col>
      </Row>

      <Row
        className={`justify-content-center  ${props.classAnimationPartners}  fix-row`}
      >
        <Col
          xs={6}
          sm={6}
          md={6}
          lg={2}
          xl={2}
          className="align-self-center align-items-center"
        >
          {/* CAROUSEL ONE - ROW 2*/}
          <div id="position" className="align-self-center">
            <img alt="ingram micro" src={ingram} />
          </div>
        </Col>
        <Col
          xs={6}
          sm={6}
          md={6}
          lg={2}
          xl={2}
          className="align-self-center align-items-center"
        >
          {/* CAROUSEL TWO - ROW 2 */}
          <div id="position" className="align-self-center">
            <img alt="lenovo" src={lenovo} />
          </div>
        </Col>
        <Col
          xs={6}
          sm={6}
          md={6}
          lg={2}
          xl={2}
          className="align-self-center align-items-center"
        >
          {/* CAROUSEL THREE - ROW 2 */}
          <div id="position" className="align-self-center">
            <img alt="licencias Online" src={licenciasOnline} />
          </div>
        </Col>
        <Col
          xs={6}
          sm={6}
          md={6}
          lg={2}
          xl={2}
          className="align-self-center align-items-center"
        >
          {/* CAROUSEL THREE - ROW 2 */}
          <div id="position">
            <img alt="fortinet" src={fortinet} />
          </div>
        </Col>
        <Col
          xs={6}
          sm={6}
          md={6}
          lg={2}
          xl={2}
          className={` align-self-center align-items-center  ${hiddenLogo}`}
        >
          {/* CAROUSEL THREE - ROW 2 */}
          <div id="position">
            <img alt="elastic" src={elastic} />
          </div>
        </Col>
      </Row>

      {/*  ROW 3 SHOW WHEN RESPONSIVE */}
      <Row
        className={`justify-content-center  ${props.classAnimationPartners}  fix-row`}
      >
        <Col
          xs={6}
          sm={6}
          md={6}
          lg={2}
          xl={2}
          className={` align-self-center align-items-center  ${showLogo}`}
        >
          {/* CAROUSEL THREE - ROW 2 */}
          <div id="position">
            <img alt="redhat" src={redHat} />
          </div>
        </Col>
        <Col
          xs={6}
          sm={6}
          md={6}
          lg={2}
          xl={2}
          className={` align-self-center align-items-center  ${showLogo}`}
        >
          {/* CAROUSEL THREE - ROW 2 */}
          <div id="position">
            <img alt="elastic" src={elastic} />
          </div>
        </Col>
      </Row>
    </>
  )
}

const mapStateToProps = state => {
  return state
}

const mapDispatchToProps = dispatch => {
  return {
    changeLang: lang => dispatch({ type: "SET_LANGUAGE", payload: lang }),
  }
}

Partners = connect(mapStateToProps, mapDispatchToProps)(Partners)
export default Partners
